export const getId = (title) => 
{
    // if title is not an string
    const header  = typeof title !== 'string' ?  title[0] : title;
        
    // returns href by transform all spaces into hyphens and lowercasing the string
    const id = header
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-');

    if (id.endsWith('-')) 
    {
        return id.slice(0, -1);
    }
    return id;
};
export const getHref = (title) => 
`#${getId(title)}`;
const articleTitleTransformer = (queried) => 
{
    const headers = queried?.parsedCollection?.h2;
    if (!headers) 
    {
        return [];
    }
    const arrayOfTitles = headers.map((header) => 
        ({
            label: header,
            href: getHref(header),
            id: getId(header),
        }));
    return arrayOfTitles;
};
export default articleTitleTransformer;
